<div id="ivsig" class="position-relative" *ngIf="showTemplate"
  [style.width]="!localSign ? ivSignModalWidth : IvDeskModalWidth">
  <div *ngIf="!localSign">
    <div class="onlyLoginSAMLSIG" *ngIf="!onlyLoginSAMLSIG">
      <p class="label-sign" class="text-center">{{ titleDialog }}</p>
    </div>
    <div class="text-center" id="titleCustom" *ngIf="customText">
      <div class="titleText">{{customText}}</div>
      <img src="assets/images/logoIvsign.png" alt="IvSign" style="height: 30px;">
    </div>
    <div class="text-center" id="titleDefault" *ngIf="!customText">
      <img src="assets/images/logoIvsign.png" alt="IvSign" style="height: 30px;">
    </div>

    <div class="ivSignModal" *ngIf="!noCert" [style.width]="valCertLoad ? '27rem' : '100%'">
      <iv-form #ivform [errorsForm]="errorMessages" [(columnsForm)]="form" [color]="color" [textColor]="textColor"
        [inModal]="true" (onEnterKey)="login();" [buttons]="null"></iv-form>
    </div>
    <div class="ivSignModal text-center" *ngIf="noCert">
      {{ 'ivsign_message_nocertificate' | translate:_transParam }}
    </div>
  </div>

  <div *ngIf="ivDeskSign && localSign" class="text-center">
    <p class="ivDeskMargin">{{(('tareasusuario_ivdesk_modal'| translate) + ' ' +
      ('tareasusuario_ivdesk_modal_2'| translate))}}</p>
    <a class="ivDeskMargin" [href]="ivDeskLink" target="_blank">IvDesk</a>
  </div>
  <div *ngIf="showErrorMessage" class="error-description">
    <p>{{messageError}}</p>
  </div>
  <div *ngIf="hasBothSigns" class="text-center containerTypeSign">
    <p>{{'external_signature_change' | translate}} <span class="typeSign" (click)="changeSign()">{{(!localSign ?
        'ivsign_signature_local' : 'ivsign_signature_centralized') | translate}}</span></p>
  </div>
</div>
